/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Ext_DeprecationInputs */

const en_misc_ext_deprecation = /** @type {(inputs: Misc_Ext_DeprecationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We've moved to the Chrome Web Store! Please install the official version and uninstall this one for the best experience.`)
};

const es_misc_ext_deprecation = /** @type {(inputs: Misc_Ext_DeprecationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Nos mudamos a la Chrome Web Store! Por favor instala la versión oficial y desinstala esta para la mejor experiencia.`)
};

/**
* | output |
* | --- |
* | "We've moved to the Chrome Web Store! Please install the official version and uninstall this one for the best experience." |
*
* @param {Misc_Ext_DeprecationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const misc_ext_deprecation = /** @type {((inputs?: Misc_Ext_DeprecationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Ext_DeprecationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_misc_ext_deprecation(inputs)
	return en_misc_ext_deprecation(inputs)
});